import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";

//internal import
import PageHeader from "../../components/common/PageHeader";
import useEmployeeSubmit from "../../hooks/useEmployeeSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import EmployeeList from "../../components/Employees/EmployeesList";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import EmployeeService from "../../services/EmployeeService";
import Uploader from "../../components/imageuploader/Uploader";
import DropDownService from "../../services/DropDownService";
import { useLocation } from 'react-router-dom';

function Employees() {

    const [employeeId, setEmployeeId] = useState("");

    const { data, loading } = useAsync(() => EmployeeService?.getAllEmployee());
    const { data: departmentDropDown, loading: departmentDropDownLoading } = useAsync(() => DropDownService.getDepartmentDropDown());
    const location = useLocation();
    const { pathname } = location;
    const { data: permissionData } = useAsync(() => DropDownService.getModulePermissions({ path: pathname, userId: localStorage.id }));
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1 : permissionData?.data?.add;
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1 : permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1 : permissionData?.data?.edit;
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1 : permissionData?.data?.delete;
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1 : permissionData?.data?.list;
    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteEmployee,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        imageUrl,
        setImageUrl,
        viewData } = useEmployeeSubmit(employeeId);

    const timezone = {
        IST: "India",
        SGT: "Singapore"
    }

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader addPermission={addPermission} headerTitle="Employee" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100 me-2" onClick={() => { setIsModal(true); setEmployeeId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Employee</button>
                        </div>
                    }} />
                    <EmployeeList deletePermission={deletePermission} editPermission={editPermission} viewPermission={viewPermission} listPermission={listPermission} setIsModal={setIsModal} setEmployeeId={setEmployeeId} setIsDeleteModal={setIsDeleteModal} setIsViewModal={setIsViewModal} data={data} timezone={timezone} />
                </>
            }
            {/* customer view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Employees Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Employee Image </b>
                                </div>
                                <div className="col-sm-6">
                                    {viewData?.employeeProfileImage ? (
                                        <img src={viewData?.employeeProfileImage} alt="employee" className="h-64 w-64" style={{ height: "200px", width: "250px" }} crossOrigin="anonymous" />
                                    ) : (
                                        <img
                                            src="https://res.cloudinary.com/ahossain/image/upload/v1655097002/placeholder_kvepfp.png"
                                            alt="slider"
                                            crossOrigin="anonymous"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Employee Code </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.employeeCode}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Employee Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.employeeName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Employee User Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.employeeUsername}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b>Email</b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.emailId}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Phone </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.phone}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Gender </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.gender}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Designation </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.designation}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> DepartMent </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.department?.departmentName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Joining Date </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.joiningDate).format("DD-MM-YYYY")}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Time Zone </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{timezone[viewData?.timezone] || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Working Hours</b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.workingHour || "-"}</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* customer add and edit modal */}
            <Modal centered show={isModal} size="lg" onHide={() => { setIsModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{employeeId ? "Update " : "Add"} Employee</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput877" className="form-label">Employee Name</label>
                                <InputArea register={register} name="employeeName" label={"Name"} type="text" className="form-control" id="exampleFormControlInput877" placeholder="Employee Name" />
                                <Error errorName={errors?.employeeName} />
                            </div>
                            <div className="deadline-form">
                                <div className="row g-3 mb-3">
                                    <div className="col-sm-6">
                                        <label htmlFor="exampleFormControlInput1780" className="form-label">Employee User Name </label>
                                        <InputArea register={register} required={"true"} label={"Name"} name="employeeUsername" type="text" className="form-control" id="exampleFormControlInput1780" placeholder="Employee User Name" />
                                        <Error errorName={errors?.employeeUsername} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput277" className="form-label">Password</label>
                                        <InputArea required={!employeeId} register={register} name="password" label={"Password"} type="Password" className="form-control" id="exampleFormControlInput277" placeholder="Password" />
                                        <Error errorName={errors?.password} />
                                    </div>
                                    <div className="col-sm-6">
                                        <label htmlFor="exampleFormControlInput1778" className="form-label">Email ID</label>
                                        <InputArea register={register} name="emailId" label={"Email"} type="email" className="form-control" id="exampleFormControlInput1778" placeholder="Email ID" />
                                        <Error errorName={errors?.emailId} />
                                    </div>
                                    <div className="col-sm-6">
                                        <label htmlFor="exampleFormControlInput27789" className="form-label">Joining Date</label>
                                        <InputArea register={register} name="joiningDate" label={"Date"} type="date" className="form-control" id="exampleFormControlInput2779" />
                                        <Error errorName={errors?.joiningDate} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput777" className="form-label">Phone</label>
                                        <InputArea register={register} name="phone" label={"Phone"} type="text" className="form-control" id="exampleFormControlInput777" placeholder="Phone" onWheel={(e) => e.target.blur()} />
                                        <Error errorName={errors?.phone} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label">Department</label>
                                        <select className="form-select" name="department+"
                                            {...register(`department`, {
                                                required: `Department is required!`
                                            })} >
                                            <option value="" defaultValue >Select DepartMent</option>
                                            {!departmentDropDownLoading && departmentDropDown?.data?.map((val, idx) => (
                                                <option key={idx} value={val?.value}>{val?.label}</option>
                                            ))}
                                        </select>
                                        <Error errorName={errors?.department} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label">Designation</label>
                                        <select className="form-select" name="department+"
                                            {...register(`designation`, {
                                                required: `Department is required!`
                                            })} >
                                            <option value="" defaultValue >Select Designation</option>
                                            <option value="Web Development" >Web Development</option>
                                            <option value="It Management">It Management</option>
                                            <option value="Marketing">Marketing</option>
                                        </select>
                                        <Error errorName={errors?.department} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label">Gender</label>
                                        <select className="form-select" name="gender"
                                            {...register(`gender`, {
                                                required: `Gender is required!`
                                            })} >
                                            <option value="" defaultValue >Select Gender</option>
                                            <option value="Men" >Male</option>
                                            <option value="Women">Female</option>
                                        </select>
                                        <Error errorName={errors?.gender} />
                                    </div>
                                    <div className="col-lg-6 flex">
                                        <div>
                                            <label className="form-label">Timezone</label>
                                            <select className="form-select" name="gender"
                                                {...register(`timezone`, {
                                                    required: `Timezone is required!`
                                                })} >
                                                <option value="" defaultValue >Select Timezone</option>
                                                <option value="IST" >India</option>
                                                <option value="SGT">Singapore</option>
                                            </select>
                                            <Error errorName={errors?.timezone} />
                                        </div>
                                        <div className="mt-2">
                                            <label htmlFor="exampleFormControlInput7778" className="form-label">Working Hour</label>
                                            <InputArea
                                                register={register}
                                                name="workingHour"
                                                label={"Working Hour"}
                                                type="text"
                                                className="form-control" id="exampleFormControlInput7778"
                                                placeholder="hour"
                                                onWheel={(e) => e.target.blur()} />
                                            <Error errorName={errors?.phone} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label">Image</label>
                                        <Uploader
                                            imageUrl={imageUrl}
                                            setImageUrl={setImageUrl}
                                            folder="slider"
                                            name="image"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{employeeId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* customer delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Employee ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteEmployee(employeeId)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default Employees;